import React from 'react';
import { VERDICT_COLOR, fmtPts, fmtInterval } from '../../utils/influenceScorecard';

// Horizontal 95% interval on a fixed symmetric axis with a zero line; the dot is the point estimate.
export default function IntervalBar({ lift, lo, hi, verdict, axis = 12, width = 220, label }) {
  const h = 26;
  if (lift == null || lo == null || hi == null) {
    return <span aria-label={label || 'interval unavailable'} style={{ color: '#757575', fontSize: 12 }}>no interval (too few closed deals)</span>;
  }
  const clamp = (v) => Math.max(-axis, Math.min(axis, v));
  const x = (v) => ((clamp(v) + axis) / (2 * axis)) * (width - 8) + 4;
  const color = VERDICT_COLOR[verdict] || '#616161';
  return (
    <svg width={width} height={h} role="img" aria-label={label || `${fmtPts(lift)} ${fmtInterval(lo, hi)}`}>
      <line x1={4} x2={width - 4} y1={h / 2} y2={h / 2} stroke="#e0e0e0" strokeWidth={1} />
      <line x1={x(0)} x2={x(0)} y1={3} y2={h - 3} stroke="#757575" strokeWidth={1.5} />
      <line x1={x(lo)} x2={x(hi)} y1={h / 2} y2={h / 2} stroke={color} strokeWidth={4} strokeLinecap="round" />
      <circle cx={x(lift)} cy={h / 2} r={5} fill={color} stroke="#fff" strokeWidth={1.5} />
    </svg>
  );
}
